import {ConfEnv} from "../config/config";
import privateRequest from "../Infra/http/private.request";

export const postResendEmailVerification = () => {
  return privateRequest.post(`${ConfEnv.API_URL.URL_RESEND_EMAIL_VERIFICATION}`, null);
};
